const IS_FILTER_PROVIDER_NON_REPO_SCOPE_VALUES_ENUM = {
  public: 'public',
  private: 'private',
} as const

const IS_FILTER_PROVIDER_VALUES_ENUM = {
  closed: 'closed',
  draft: 'draft',
  issue: 'issue',
  locked: 'locked',
  merged: 'merged',
  unmerged: 'unmerged',
  open: 'open',
  pr: 'pr',
  unlocked: 'unlocked',
  blocked: 'blocked',
  blocking: 'blocking',
  queued: 'queued',
} as const

type IS_FILTER_PROVIDER_VALUES = Array<keyof typeof IS_FILTER_PROVIDER_VALUES_ENUM>

/**
 * Default values for the IsFilterProvider
 */
export const IS_FILTER_PROVIDER_VALUES: IS_FILTER_PROVIDER_VALUES = Object.values(IS_FILTER_PROVIDER_VALUES_ENUM)

type IS_FILTER_PROVIDER_NON_REPO_SCOPE_VALUES = Array<
  keyof typeof IS_FILTER_PROVIDER_VALUES_ENUM | keyof typeof IS_FILTER_PROVIDER_NON_REPO_SCOPE_VALUES_ENUM
>

/**
 * A superset of values for the IsFilterProvider used within the issues dashboard, including repository and issue scope
 */
export const IS_FILTER_PROVIDER_NON_REPO_SCOPE_VALUES: IS_FILTER_PROVIDER_NON_REPO_SCOPE_VALUES = [
  ...Object.values(IS_FILTER_PROVIDER_NON_REPO_SCOPE_VALUES_ENUM),
  ...IS_FILTER_PROVIDER_VALUES,
]
